/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
import { useEffect, useState, useRef, useCallback } from 'react';
import { motion, useInView } from 'framer-motion';
import { XumoButton, StackedContent, useSanitizedTranslation, useInViewScroll } from 'ui';
import { ToggleModalFn } from './BannerCarousel';

export interface ModalProps {
  showModal: boolean;
  headingBold?: string;
  heading?: string;
  disclaimer?: string;
  body?: string;
  ctaLabel?: string;
  id?: string;
  toggleModal: ToggleModalFn;
}

export const Modal = ({ showModal, toggleModal, headingBold, heading, disclaimer, body, ctaLabel, id }: ModalProps) => {
  const { t } = useSanitizedTranslation();

  const { ref, progress: amt } = useInViewScroll([0, 1], ['start 100vh', 'end 0vh']);
  const inView = useInView(ref, { once: true, margin: '-30% 0% -30% 0%' });

  useEffect(() => {
    if (showModal) {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    return () => {
      if (showModal) {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    };
  }, [showModal]);

  if (showModal) {
    return (
      <div className="fixed bottom-0 left-0 right-0 top-0 z-50 flex h-screen w-screen justify-center overflow-hidden bg-black bg-opacity-60 p-4 sm:items-center">
        <div className="relative h-fit max-h-[90vh] w-full max-w-4xl overflow-auto rounded-lg bg-white shadow-xl">
          <div className="absolute right-4 top-4 z-50 flex items-center">
            <button onClick={toggleModal} className="flex h-8 w-8 items-center justify-center rounded-sm text-gray-700">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          <div className="flex w-full flex-col px-6 py-16 md:p-10">
            <div className="text-center text-2xl md:text-left" data-i18n>
              <strong>{t(headingBold ?? '')}</strong> <span className="font-extralight">{t(heading ?? '')}</span>
            </div>

            {disclaimer && <p className="my-6 opacity-70">{disclaimer}</p>}

            <div
              className="mt-2 text-center md:text-left"
              data-i18n
              dangerouslySetInnerHTML={{
                __html: t(body ?? 'Sign up for emails from Xumo to keep up with all the latest shows and movies, new products and exclusive offers.'),
              }}
            />
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
